import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ResizeObserver from 'resize-observer-polyfill';
import { Button } from '@lt/components';
import { isElementOverflown } from '@lt/components/utils/userflow';

class ShortInfo extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOverflown: undefined,
      isClamped: true,
    };
    this.containerRef = React.createRef();
    this.handleOverflow = this.handleOverflow.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.observer = new ResizeObserver(this.handleOverflow);
    this.observer.observe(this.container);
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.unobserve(this.container);
    }
  }

  handleOverflow() {
    const { isClamped } = this.state;
    if (isClamped) {
      const isOverflown = isElementOverflown(this.container);
      this.setState({ isOverflown });
    }
  }

  handleClick() {
    this.setState({ isClamped: false });
  }

  get container() {
    return this.containerRef.current;
  }

  render() {
    const { isOverflown, isClamped } = this.state;
    const { text, maxLines, lineHeight, isMobile } = this.props;
    const showExpandBtn = isOverflown && isClamped;
    return (
      <StyledShortInfo
        ref={this.containerRef}
        expanded={!isClamped}
        maxLines={maxLines}
        lineHeight={lineHeight}
        showMobileShadow={isMobile && showExpandBtn}
        onClick={isMobile ? this.handleClick : undefined}
      >
        {text}
        {!isMobile && showExpandBtn && (
          <StyledButton onClick={this.handleClick}>Подробнее</StyledButton>
        )}
      </StyledShortInfo>
    );
  }
}

ShortInfo.defaultProps = {
  maxLines: 3,
  lineHeight: 18,
  isMobile: false,
};

ShortInfo.propTypes = {
  text: PropTypes.string.isRequired,
  maxLines: PropTypes.number,
  lineHeight: PropTypes.number,
  isMobile: PropTypes.bool,
};

const StyledShortInfo = styled.div`
  position: relative;
  overflow: hidden;
  max-height: ${({ expanded, maxLines, lineHeight }) =>
    expanded ? 'none' : `${maxLines * lineHeight}px`};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.blackLight};

  ${({ showMobileShadow, lineHeight }) =>
    showMobileShadow &&
    css`
      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
        height: ${lineHeight * 2}px;
        content: '';
        background-image: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          ${({ theme }) => theme.colors.white} 100%
        );
      }
    `}
`;

const StyledButton = styled(Button).attrs({ functional: true })`
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0 0 3px 100px;
  color: ${({ theme }) => theme.colors.blue};
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    ${({ theme }) => theme.colors.white} 35%
  );
`;

export default ShortInfo;
